import BaseRepository from '@/repositories/base/BaseRepository'

class WalletRepository extends BaseRepository {
	// 获取聚意宝酒店账户信息
	getCpsAccountInfo() {
		return this.get<any>({
			url: '/ebk-dkb-api/fip-sale-room-config/get-cps-account-info',
			data: {},
		})
	}
	//修改售房充值配置
	updateConfig(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/fip-sale-room-config/update-config',
			data: params,
		})
	}
	//保存售房充值配置
	saveConfig(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/fip-sale-room-config/save-config',
			data: params,
		})
	}
	//校验预留手机号
	checkReservedPhoneNumber(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/fip-sale-room-config/check-reserved-phone-number',
			data: params,
		})
	}
	//生意金详情
	getFipSaleRoomDetail(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/fip-sale-room-config/get-fip-sale-room-detail',
			data: params,
		})
	}
	// 获取售房充值状态信息
	querySaleRoomConfigStatus() {
		return this.get<any>({
			url: '/ebk-dkb-api/fip-sale-room-config/query-sale-room-config-status',
			data: {},
		})
	}
	// 保存商户手机号白名单
	saveMerchantMobileWhitelist(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/merchant-mobile-whitelist/save',
			data: params,
		})
	}
	// 查询商户手机号白名单
	queryMerchantMobileWhitelist() {
		return this.get<any>({
			url: '/ebk-dkb-api/merchant-mobile-whitelist/query/mobile',
			data: {},
		})
	}
	// 酒店推广基本信息状态诊断工具
	getDiagnosisInfo() {
		return this.post<any>({
			url: '/ebk-dkb-api/guidance/getDiagnosisInfo',
			data: {},
		})
	}
	// 日志
	query(params: any) {
		return this.get<any>({
			url: '/ebk-dkb-api/core-system-log/query',
			data: params,
		})
	}

	// 获取钱包余额
	getWalletInfo(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/wallet/getWalletInfo',
			data: params,
		})
	}

	getRechargeRedPacketList(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/flowExpress/getRechargeRedPacketList',
			data: params,
		})
	}

	getUseRedPacket(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/getUseRedPacket',
			data: params,
		})
	}

	toPayment(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/wallet/toPayment',
			data: params,
		})
	}

	//获取支付优惠列表
	getPaymentPage(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/flowExpress/getPaymentPage',
			data: params,
		})
	}

	getPopStatus(params: any) {
		return this.get<any>({
			url: '/ebk-dkb-api/fip-sale-room-config/get-pop-status',
			data: params,
		})
	}

	redPacketTransList(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/redPacketTransList',
			data: params,
		})
	}

	getRechargeList(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/wallet/getRechargeList',
			data: params,
		})
	}

	getConsumeList(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/wallet/getConsumeList',
			data: params,
		})
	}

	getRedPackConsumeList(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/consumeList',
			data: params,
		})
	}

	getSmsMarketMessageLogs(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/market/getSmsMarketMessageLogs',
			data: params,
		})
	}

	accountTradeCancel(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/wallet/accountTradeCancel',
			data: params,
		})
	}

	cpsPopout(params: any) {
		return this.get<any>({
			url: '/ebk-dkb-api/cps-apply-order/cps-popout',
			data: params,
		})
	}

	// 计算预付充值金额
	calculateRechargePrice(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/redPacket/calculate-recharge-price',
			data: params,
		})
	}

	// 查询支付单列表
	getPaymentOrderList(params: any) {
		return this.get<any>({
			url: '/ebk-dkb-api/ota-payment/query-payment-order-list',
			data: params,
		})
	}

	otaPayment(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/ota-payment/payment',
			data: params,
		})
	}

	cancelPayOrder(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/ota-payment/cancel-pay-order',
			data: params,
		})
	}

	existOtaContract() {
		return this.get<any>({
			url: '/ebk-dkb-api/ota-payment/exist-ota-contract',
			data: {},
		})
	}
}

export default WalletRepository
